import { Button, message, Modal, Select } from 'antd';
import gql from 'graphql-tag';
import React, { Component } from 'react';
import { Mutation } from 'react-apollo';

import { WORKERS_QUERY } from './constant';
import { Role } from './type';

interface State {
  isShowModal: boolean;
  roles: Role[];
}

interface Props {
  allRoles: Role[];
  userId: number;
  defaultRoles: Role[];
}

const updateWorkerUserMutation = gql`
  mutation updateWorkerUser($userId: ID!, $roleIds: [ID]!) {
    updateWorkerUser(userId: $userId, roleIds: $roleIds) {
      id
      name
      mobile
      roles {
        id
        name
      }
    }
  }
`;

export class EditWorker extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isShowModal: false,
      roles: props.defaultRoles,
    };
  }

  hideModal = () => {
    this.setState({ isShowModal: false });
  };

  showModal = () => {
    this.setState({ isShowModal: true });
  };

  onRolesChange = (values: string[]) => {
    const { allRoles } = this.props;
    const roles: Role[] = [];
    values.forEach(name => {
      const role = allRoles.find(role => role.name === name);
      if (role) {
        roles.push(role);
      }
    });
    this.setState({ roles });
  };

  render() {
    const { userId, allRoles } = this.props;
    const { roles, isShowModal } = this.state;
    const roleIds = roles.map(role => Number(role.id));
    const defaultValue = roles.map(role => `${role.name}`);
    return (
      <div>
        <Button type="primary" onClick={this.showModal}>
          编辑
        </Button>
        <Mutation
          mutation={updateWorkerUserMutation}
          variables={{ userId, roleIds }}
          refetchQueries={[{ query: WORKERS_QUERY }]}
        >
          {updateWorkerUser => {
            return (
              <Modal
                title="编辑员工角色"
                visible={isShowModal}
                onOk={async () => {
                  try {
                    if (roleIds && roleIds.length) {
                      await updateWorkerUser();
                      this.setState({ isShowModal: false });
                      message.success('编辑成功！');
                      return;
                    }
                    message.error('请将信息填写完整！');
                  } catch {
                    message.error('编辑失败！');
                  }
                }}
                onCancel={this.hideModal}
              >
                <Select
                  mode="multiple"
                  style={{ width: '100%' }}
                  placeholder="请选择"
                  defaultValue={defaultValue}
                  onChange={this.onRolesChange}
                >
                  {allRoles.map(role => {
                    return <Select.Option key={role.name}>{role.name}</Select.Option>;
                  })}
                </Select>
              </Modal>
            );
          }}
        </Mutation>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/rolePermission/EditWorker.tsx